"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sidebar_component_1 = __importDefault(require("./sidebar.component"));
exports.default = sidebar_component_1.default;
